import { Currencies } from '@/entities/curency'
import { formatCurrency, formatDate } from '@/shared/lib'
import { MerchantDashboardStatModel } from '../../model'
import { DashboardCard, DashboardCardModel } from '@/entities/dashboard'
import { ApiError } from '@/api/types'

type Props = {
  statistic: MerchantDashboardStatModel | undefined
  isLoading: boolean
  error: ApiError | null
}

export const MerchantDashboardCards = ({ statistic, isLoading, error }: Props) => {
  const today = formatDate(String(new Date()), 'withoutSeconds')
  const cards: DashboardCardModel[] = [
    {
      id: 0,
      title: 'Сумма сделок в процессе',
      value: error
        ? 'Ошибка загрузки данных.'
        : formatCurrency(statistic?.allTopupInProgress.totalAmountTo ?? 0, Currencies.USDT),
      date: today,
      tooltip: 'Сумма входях платежей, которые сейчас находятся в процессе поступления',
    },
    {
      id: 1,
      title: 'Спорные транзакции',
      value: error
        ? 'Ошибка загрузки данных.'
        : formatCurrency(statistic?.disput.amountFromMerchantUsdt ?? 0, Currencies.USDT),
      transactionsCount: statistic?.disput.totalCount ?? 0,
      linkName: 'Показать все',
      link: '/orders',
    },
    // {
    //   id: 2,
    //   title: 'Сумма исходящих сделок',
    //   value: error
    //     ? 'Ошибка загрузки данных.'
    //     : formatCurrency(statistic?.withdraw?.paidAmountFrom ?? 0, Currencies.USDT),
    //   transactionsCount: statistic?.withdraw?.paidCount,
    //   linkName: 'Показать все',
    //   link: '/payout',
    // },
  ]

  return (
    <>
      {cards.map((card) => (
        <DashboardCard key={card.id} card={card} isLoading={isLoading} />
      ))}
    </>
  )
}
